import { WarningIcon } from "@chakra-ui/icons";
import { Box, Alert, AlertIcon, AlertTitle, AlertDescription } from "@chakra-ui/react";

function WarningBanner() {
  return (
    <Alert status="warning" borderRadius="md" mb={4}>
      <AlertIcon />
      <Box>
        <AlertTitle fontSize="sm">Whitelisted account required </AlertTitle>
        
      </Box>
    </Alert>
  );
}

export default WarningBanner;
